<template>
  <div class="form-item">
    <label>打刻修正</label>
    <template v-if="syuuseis">
      <template v-for="(syuusei, index) in syuuseis">
        <div :class="{'item-border': index > 0}"></div>
        <template v-if="syuusei.is_torikeshi">
          <div class="before-after shinsei">
            <p class="before" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">打刻取消</p>
          </div>
        </template>

        <template v-else>
          <div class="before-after shinsei">
            <label class="title">出勤</label>
            <p class="before">{{ syuusei.before_syukkin_datetime ? timeFormat(syuusei.before_syukkin_datetime) : '記録なし' }}
            </p>
            <p class="arrow">→</p>
            <p class="after" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{
              syuusei.syukkin_datetime ? timeFormat(syuusei.syukkin_datetime) : '記録なし' }}</p>
          </div>
          <div class="before-after shinsei">
            <label class="title">退勤</label>
            <p class="before">{{ syuusei.before_taikin_datetime ? timeFormat(syuusei.before_taikin_datetime) : '記録なし' }}
            </p>
            <p class="arrow">→</p>
            <p class="after" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{
              syuusei.taikin_datetime ? timeFormat(syuusei.taikin_datetime) : '記録なし' }}</p>
          </div>
          <div class="before-after shinsei">
            <label class="title">外出</label>
            <p class="before">{{ syuusei.before_gaisyutsu_datetime ? timeFormat(syuusei.before_gaisyutsu_datetime) :
              '記録なし' }}</p>
            <p class="arrow">→</p>
            <p class="after" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{
              syuusei.gaisyutsu_datetime ? timeFormat(syuusei.gaisyutsu_datetime) : '記録なし' }}</p>
          </div>
          <div class="before-after shinsei">
            <label class="title">戻り</label>
            <p class="before">{{ syuusei.before_modori_datetime ? timeFormat(syuusei.before_modori_datetime) : '記録なし' }}
            </p>
            <p class="arrow">→</p>
            <p class="after" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{
              syuusei.modori_datetime ? timeFormat(syuusei.modori_datetime) : '記録なし' }}</p>
          </div>
          <div class="before-after shinsei">
            <label class="title">休憩</label>
            <p class="before">{{ syuusei.before_modori_datetime ? timeFormat(syuusei.before_modori_datetime) : '記録なし' }}
            </p>
            <p class="arrow">→</p>
            <p class="after" :class="{ 'applying': syuusei.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{
              syuusei.modori_datetime ? timeFormat(syuusei.modori_datetime) : '記録なし' }}</p>
          </div>
        </template>
      </template>
    </template>

    <template v-else>
      <div class="before-after shinsei">
        <p>{{ 'なし' }}</p>
      </div>
    </template>
  </div>

  <div class="form-item">
    <label>有給</label>
    <div class="before-after shinsei">
      <template v-if="detailData && Boolean(detailData.is_yuukyuu).valueOf()">
        <template v-if="detailData.yuukyuu_tani_type === OptionConst.SHINSEI_DIV.FULL_DAY">
          <p class="before">1日有給</p>
        </template>
        <template v-if="detailData.yuukyuu_tani_type === OptionConst.SHINSEI_DIV.AM">
          <p class="before">AM有給</p>
        </template>
        <template v-if="detailData.yuukyuu_tani_type === OptionConst.SHINSEI_DIV.PM">
          <p class="before">PM有給</p>
        </template>
      </template>
      <template v-else-if="shinseis.yuukyuu.length > 0">
        <template v-for="item in shinseis.yuukyuu">
          <p :class="{ 'applying': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{ item.notes }}</p>
        </template>
      </template>
      <template v-else>
        <p>{{ 'なし' }}</p>
      </template>
    </div>
  </div>

  <div class="form-item">
    <label>振休・振出</label>
    <div class="before-after shinsei">
      <template v-if="detailData && Boolean(detailData.is_furide).valueOf()">
        <p class="before">振出</p>
      </template>
      <template v-else-if="detailData && Boolean(detailData.is_furikyuu).valueOf()">
        <template v-if="detailData.furikyuu_tani_type === OptionConst.SHINSEI_DIV.FULL_DAY">
          <p class="before">1日振休</p>
        </template>
        <template v-if="detailData.furikyuu_tani_type === OptionConst.SHINSEI_DIV.AM">
          <p class="before">AM振休</p>
        </template>
        <template v-if="detailData.furikyuu_tani_type === OptionConst.SHINSEI_DIV.PM">
          <p class="before">PM振休</p>
        </template>
      </template>
      <template v-else-if="shinseis.furikyuu.length > 0">
        <template v-for="item in shinseis.furikyuu">
          <p :class="{ 'applying': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{ item.notes }}</p>
        </template>
      </template>
      <template v-else>
        <p>{{ 'なし' }}</p>
      </template>
    </div>
  </div>

  <div class="form-item">
    <label>欠勤</label>
    <div class="before-after shinsei">
      <template v-if="detailData && Boolean(detailData.is_kekkin).valueOf()">
        <p class="before">欠勤</p>
      </template>
      <template v-else-if="shinseis.kekkin.length > 0">
        <template v-for="item in shinseis.kekkin">
          <p :class="{ 'applying': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{ dateFormat(item.notes) }}</p>
        </template>
      </template>
      <template v-else>
        <p>{{ 'なし' }}</p>
      </template>
    </div>
  </div>

  <div class="form-item">
    <label>時間外</label>
    <div class="shinsei">
      <template v-if="shinseis.jikangai.length > 0">
        <template v-for="item in shinseis.jikangai">
          <p :class="{ 'applying': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{ item.notes }}</p>
        </template>
      </template>
      <template v-else>
        <p>{{ 'なし' }}</p>
      </template>
    </div>
  </div>

  <div class="form-item">
    <label>休憩未取得</label>
    <div class="shinsei">
      <template v-if="shinseis.kyuukei.length > 0">
        <template v-for="item in shinseis.kyuukei">
          <p :class="{ 'applying': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT }">{{ timeFormatter(item.notes) }}</p>
        </template>
      </template>
      <template v-else>
        <p>{{ 'なし' }}</p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import OptionConst from "@/const/Option";
import { HayabanOsoban } from '@/types/Shinsei';
import { DakokuDetailData, DakokuInfoShinsei } from '@/types/Dakoku';
import { timeFormat, dateFormat } from '@/filters/common';
import dayjs from 'dayjs';

export default defineComponent({
  props: {
    hayabanOsobanData: {
      type: Object as () => HayabanOsoban,
      default: null
    },
    shinseis: {
      type: Object as () => DakokuInfoShinsei,
      default: null
    },
    detailData: {
      type: Object as () => DakokuDetailData
    },
  },
  setup(props) {
    const getShinseiName = (type: number) => {
      return OptionConst.SHINSEI_OPTION.find(v => v.val == type)?.label
    }

    const syuuseis: any = computed(() => {
      if (!props.shinseis) {
        return null
      }
      if (!props.shinseis.syuusei) {
        return null
      }
      if (props.shinseis.syuusei.length > 0) {
        return props.shinseis.syuusei.map(item => item.notes)
      }
      return null
    })

    const timeFormatter = (time: string): string => {
      return timeFormat(dayjs().date() + ' ' + time)
    }

    return {
      getShinseiName,
      OptionConst,
      syuuseis,
      timeFormat,
      dateFormat,
      timeFormatter,
    }
  }
})
</script>

<style lang="scss" scoped>@import '@scss/dialog/dakoku-syuusei.scss';</style>
